import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "delete-content" }
const _hoisted_3 = { class: "text" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_AlertBanner = _resolveComponent("AlertBanner")
  const _component_Button = _resolveComponent("Button")
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createBlock(_component_Modal, {
    ref: "modal",
    max_width: _ctx.$responsive.mobile ? 'calc(100% - 3.2rem)' : '48rem',
    min_width: _ctx.$responsive.mobile ? '0' : undefined,
    centered: false
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createTextVNode(" Delete tracker ")),
        _createVNode(_component_Icon, {
          icon: "x-close",
          class: "pointer",
          size: "1.6rem",
          "stoke-width": "1",
          disabled: $data.loading,
          onClick: $options.close
        }, null, 8 /* PROPS */, ["disabled", "onClick"])
      ])
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[1] || (_cache[1] = _createTextVNode(" Are you sure you want to delete the ")),
          _createElementVNode("b", null, _toDisplayString($data.tracker.name), 1 /* TEXT */),
          _cache[2] || (_cache[2] = _createTextVNode(" tracker? "))
        ]),
        ($options.persona_count)
          ? (_openBlock(), _createBlock(_component_AlertBanner, {
              key: 0,
              class: "alert-banner",
              type: "error"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Please note that you have " + _toDisplayString($options.pluralized) + " for this company. They will also be removed. ", 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    controls: _withCtx(() => [
      _createVNode(_component_Button, {
        disabled: $data.loading,
        onClick: $options.close
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode(" Cancel ")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled", "onClick"]),
      _createVNode(_component_Button, {
        primary: "",
        loading: $data.loading,
        onClick: $options.deleteTracker
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [
          _createTextVNode(" Delete ")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["loading", "onClick"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["max_width", "min_width"]))
}